import { Component, OnInit } from '@angular/core';
import {FilterHandlerService} from '../../services/filter-handler.service';
import {HttpItemsService} from '../../services/http/http-items.service';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.scss']
})
export class ProjectListComponent implements OnInit {

  filters: any;
  projects: any;
  fullText: string;

  constructor(
    private filterHandlerService: FilterHandlerService,
    private httpItemsService: HttpItemsService
  ) { }

  ngOnInit() {
    this.filterHandlerService.onFilterChange().subscribe((filters) => {
      console.log('P5i3el sign8l<<<<');
      this.filters = filters.filters;
      this.fullText = filters.fullText;
    });
    if (this.filters == null) {
      this.filters = this.filterHandlerService.getFilters();
      this.fullText = this.filterHandlerService.getFulltext();
    }
    this.getProjects();
    this.filterHandlerService.onReloadDataSignal().subscribe(() => {
      //console.log('WTFFFFF');
      this.getProjects();
    });
  }

  private getProjects() {
    this.httpItemsService.getFilteredItems({filters: this.filters, fullText: this.fullText}).subscribe((result) => {
      this.projects = result.body;
    });
  }
}
